var modules_7fc2511b = {"dots":"PaginationButton_module_dots__66040bf9","selected-page":"PaginationButton_module_selectedPage__66040bf9"};
import "../../../assets/esm/components/Table/src/PaginationButton~DD2DXLO1.css";

export { modules_7fc2511b as default };
//# sourceMappingURL=PaginationButton.module.less.js.map
